@if (orders.value.length > 0) {
  <table mat-table [dataSource]="orders" multiTemplateDataRows>
    <ng-container matColumnDef="orderTypeID">
      <th mat-header-cell *matHeaderCellDef id="orderTypeID"> {{ 'common.labels.type' | transloco }} </th>
      <td mat-cell *matCellDef="let order"> {{ order.orderTypeID | enumLabel:'orderType':order.orderType.name }} </td>
    </ng-container>
    <ng-container matColumnDef="orderStatusTypeID">
      <th mat-header-cell *matHeaderCellDef id="orderStatusTypeID"> {{ 'common.labels.status' | transloco }}
      </th>
      <td mat-cell *matCellDef="let order">
        <div class="flex-container-vertical-center">
          <lib-order-status [order]="order"></lib-order-status><span>{{ order.orderStatusTypeID | enumLabel:'orderStatusType' }} </span>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="criteria">
      <th mat-header-cell *matHeaderCellDef id="criteria"> {{ 'common.labels.criteria' | transloco }} </th>
      <td mat-cell *matCellDef="let order"> {{ getSearchCriteria(order) }} </td>
    </ng-container>
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef id="country"> {{ 'common.labels.country' | transloco }} </th>
      <td mat-cell *matCellDef="let order"> {{ order.country }} </td>
    </ng-container>
    <ng-container matColumnDef="jurisdiction">
      <th mat-header-cell *matHeaderCellDef id="jurisdiction"> {{ 'common.labels.jurisdiction' | transloco }}
      </th>
      <td mat-cell *matCellDef="let order">{{ order.displayJurisdiction }}
        <td>
        </ng-container>
        <ng-container matColumnDef="documents">
          <th mat-header-cell *matHeaderCellDef id="documents"> {{ 'multiSearchOrders.documents' | transloco }}
          </th>
          <td mat-cell *matCellDef="let order">
            @if (order.searchResult) {
              <lib-download-search-documents [order]="order"></lib-download-search-documents>
            }
            <td>
            </ng-container>
            <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
              <td mat-cell *matCellDef="let order">
                <button mat-icon-button color="accent" (click)="viewOrder(order, false)" [attr.aria-label]="'common.labels.viewOrder' | transloco">
                  <mat-icon>article</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="viewOrder(order, true)" [attr.aria-label]="'common.labels.viewOrderInNewTab' | transloco">
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let order; columns: displayedColumns;" class="expandable-table-row">
            </tr>
          </table>
        }